import { Controller } from "@hotwired/stimulus";

// Folds the in-progress transfer-form state into a consent link's `return_to`
// before Turbo follows it. Signing consent re-navigates the drawer to a fresh
// GET, and the transfer isn't persisted yet, so the return URL is the only
// place to stash the org, message, and enrollment picks the user already made.
export default class extends Controller {
  capture(event: Event) {
    const link = event.currentTarget as HTMLAnchorElement;
    const form = link.closest("form");
    if (!form) return;

    const url = new URL(link.href);
    const returnTo = url.searchParams.get("return_to");
    if (!returnTo) return;

    const destination = new URL(returnTo, window.location.origin);
    for (const [name, value] of new FormData(form).entries()) {
      if (typeof value !== "string" || value === "") continue;
      destination.searchParams.append(name, value);
    }

    url.searchParams.set("return_to", destination.pathname + destination.search);
    link.href = url.toString();
  }
}
